<template>
  <b-modal
    v-model="isOpen"
    centered
    size="md"
    header-class="modal-header-full"
    footer-class="d-none"
    hide-header-close
    @hide="handleCancel">

    <template #title>
      <div class="header-layout">
        <div class="header-left">
          <div class="d-flex align-items-center gap-2">
            <AlertTriangle :size="20" class="text-danger" />
            <strong>{{ title }}</strong>
          </div>
        </div>
        <div class="header-actions">
          <b-button variant="outline-secondary" size="sm" @click="handleCancel()">
            {{ $t('Webportal.Dialog.Cancel')}}
          </b-button>
          <b-button variant="danger" size="sm" @click="handleConfirm">
            {{ confirmText }}
          </b-button>
        </div>
      </div>
    </template>

    <template #default>
      <p class="mb-2">{{ message }}</p>
      <p v-if="itemName" class="mb-0">
        <strong>{{ itemName }}</strong>
      </p>
      <p v-if="warning" class="text-muted small mt-3 mb-0">
        {{ warning }}
      </p>
    </template>

  </b-modal>
</template>

<script>
import { AlertTriangle, Trash2 } from 'lucide-vue-next';

export default {
  name: 'ModalConfirmDelete',

  components: {
    AlertTriangle,
    Trash2
  },

  data() {
    return {
      isOpen: false,
      resolvePromise: null,
      rejectPromise: null,
      title: 'Löschen bestätigen',
      message: 'Möchten Sie dieses Element wirklich löschen?',
      itemName: null,
      warning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      confirmText: this.$t('Webportal.Dialog.ConfirmDelete.Title')
    };
  },

  methods: {
    open(options = {}) {
      this.title = options.title || 'Löschen bestätigen';
      this.message = options.message || 'Möchten Sie dieses Element wirklich löschen?';
      this.itemName = options.itemName || null;
      this.warning = options.warning || 'Diese Aktion kann nicht rückgängig gemacht werden.';
      this.confirmText = options.confirmText || this.$t('Webportal.Dialog.ConfirmDelete.Title');

      this.isOpen = true;

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    handleConfirm() {
      this.isOpen = false;
      if (this.resolvePromise) {
        this.resolvePromise(true);
      }
    },

    handleCancel() {
      this.isOpen = false;
      if (this.rejectPromise) {
        this.rejectPromise(false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.text-danger {
  color: var(--bs-danger);
}
</style>
